var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 30.75C26.3242 30.75 26.3967 30.772 26.4583 30.8132C26.52 30.8544 26.5681 30.913 26.5965 30.9815C26.6248 31.05 26.6323 31.1254 26.6178 31.1982C26.6033 31.2709 26.5676 31.3377 26.5152 31.3902C26.4627 31.4426 26.3959 31.4783 26.3232 31.4928C26.2504 31.5073 26.175 31.4998 26.1065 31.4715C26.038 31.4431 25.9794 31.395 25.9382 31.3333C25.897 31.2717 25.875 31.1992 25.875 31.125C25.875 31.0255 25.9145 30.9302 25.9848 30.8598C26.0552 30.7895 26.1505 30.75 26.25 30.75Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 27.75V23.25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.507 18.7498C27.3854 18.5221 27.2043 18.3317 26.9829 18.199C26.7615 18.0662 26.5082 17.9961 26.25 17.9961C25.9919 17.9961 25.7386 18.0662 25.5172 18.199C25.2958 18.3317 25.1146 18.5221 24.993 18.7498L17.409 33.2023C17.297 33.4152 17.2424 33.6536 17.2506 33.894C17.2587 34.1344 17.3294 34.3685 17.4555 34.5733C17.5833 34.7792 17.7616 34.949 17.9735 35.0666C18.1853 35.1842 18.4237 35.2457 18.666 35.2453H33.834C34.0763 35.2457 34.3147 35.1842 34.5266 35.0666C34.7384 34.949 34.9167 34.7792 35.0445 34.5733C35.1707 34.3685 35.2414 34.1344 35.2495 33.894C35.2577 33.6536 35.2031 33.4152 35.091 33.2023L27.507 18.7498Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 21.75H3C2.40326 21.75 1.83097 21.5129 1.40901 21.091C0.987053 20.669 0.75 20.0967 0.75 19.5V3C0.75 2.40326 0.987053 1.83097 1.40901 1.40901C1.83097 0.987053 2.40326 0.75 3 0.75H30C30.5967 0.75 31.169 0.987053 31.591 1.40901C32.0129 1.83097 32.25 2.40326 32.25 3V15.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6004 1.41992L16.4999 13.5009L1.39941 1.41992",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeWarning);
export default __webpack_public_path__ + "static/media/envelope-warning.6d168500b482734e994386f7e9277f3f.svg";
export { ForwardRef as ReactComponent };